module.exports = __webpack_public_path__ + "static/media/GPS.625025b2.svg";